import { httpsMultipart } from 'shared/utils/https';
import type { IUploadFilesResponseDTO } from './upload-files.dto';

const baseURL = '/v1/upload-files';

export const uploadFilesData = {
  uploadFiles: async (formData: FormData): Promise<IUploadFilesResponseDTO> => {
    const response = await httpsMultipart.post<IUploadFilesResponseDTO>(baseURL, formData);

    const { data } = response;

    return data;
  },
};
